<template>
    <el-form ref="form" :rules="rules" :model="dioForm" label-width="200px">
        <el-form-item prop="type">
            <label slot="label">
                <span>{{ $t('resource.in') }}-{{ `[${$t(clickMenu)}]` }}-{{ $t('resource.menu') }}-{{ title }}</span>
            </label>
            <el-select style="width: 250px" :disabled="handleStatus !== 'Add'" v-model.trim="dioForm.type" @change="changeMenu">
                <el-option v-for="item in typeArray" :key="item.id" :label="$t(item.label)" :value="item.id"></el-option>
            </el-select>
        </el-form-item>
        <h3>{{ $t('resource.menuMsg') }}</h3>
        <el-form-item prop="url" :label="$t('resource.intry')">
            <el-input v-model.trim="dioForm.url" style="width: 250px" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item prop="name" :label="$t('resource.name')">
            <el-input v-model.trim="dioForm.name" style="width: 250px" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="nameZh" :label="$t('resource.nameZh')">
            <el-input v-model.trim="dioForm.nameZh" style="width: 250px" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="nameEn" :label="$t('resource.nameEn')">
            <el-input v-model.trim="dioForm.nameEn" style="width: 250px" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="code" :label="$t('resource.code')">
            <el-input :disabled="handleStatus !== 'Add'" v-model.trim="dioForm.code" style="width: 250px" maxlength="80"></el-input>
        </el-form-item>
        <el-form-item prop="enable" :label="$t('resource.enable')">
            <el-select style="width: 250px" v-model.trim="dioForm.enable">
                <el-option v-for="item in statusArray" :key="item.id" :label="$t(item.label)" :value="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="view" :label="$t('resource.visualRole')">
            <div class="uk-flex uk-flex-middle">
                <el-select style="width: 250px" v-model.trim="dioForm.view">
                    <el-option v-for="item in shareParamArray" :key="item.code" :label="$t('public.' + item.content)" :value="item.code"></el-option>
                </el-select>
                <i class="el-icon-question" :title="$t(levelArrayTitle[dioForm.view])" style="margin-left:10px;cursor: pointer;"></i>
            </div>
        </el-form-item>
        <el-form-item prop="icon" :label="$t('resource.icon')">
            <i :class="dioForm.icon" @click="changeIcon" style="margin-top:3px"></i>
        </el-form-item>
        <v-drawer :visible.sync="drawer" @choozeIcon="choozeIcon" />
    </el-form>
</template>

<script>
import DrawerVue from './Drawer.vue';

export default {
    props: ['isChildren', 'clickMenu', 'handleStatus', 'title', 'treeChooze', 'shareParamArray'],
    components: {
        'v-drawer': DrawerVue
    },
    watch: {
        isChildren: {
            handler: function(newVal) {
                if (!newVal) {
                    this.typeArray = [
                        {
                            id: 1,
                            label: 'resource.peerMenu'
                        },
                        {
                            id: 2,
                            label: 'resource.subMenu'
                        }
                    ];
                } else {
                    this.typeArray = [
                        {
                            id: 1,
                            label: 'resource.peerMenu'
                        }
                    ];
                }
            },
            immediate: true
        }
    },
    computed: {
        rules() {
            return {
                url: [{ required: false, message: this.$t('resource.intry') + this.$t('resource.nameNotEmpty'), trigger: 'blur' }],
                name: [{ required: true, message: this.$t('resource.nameNotEmpty'), trigger: 'blur' }],
                nameZh: [{ required: true, message: this.$t('resource.nameZhNotEmpty'), trigger: 'blur' }],
                nameEn: [{ required: true, message: this.$t('resource.nameEnNotEmpty'), trigger: 'blur' }],
                code: [
            { required: true, message: this.$t('resource.codeNotEmpty'), trigger: 'blur' },
            {
                validator: this.$fromRules.FormValidate.Form().ParamCode,
                trigger: 'blur'
            }
        ],
                icon: [{ required: true, message: this.$t('resource.iconNotEmpty'), trigger: 'blur' }]
            };
        }
    },
    data() {
        return {
            dioForm: {
                type: 1,
                name: null,
                nameZh: null,
                nameEn: null,
                code: null,
                url: null,
                // extra_code:null,
                enable: 1,
                view: '0',
                icon: 'el-icon-question',
                Text: ''
            },
            typeArray: [
                {
                    id: 1,
                    label: 'resource.peerMenu'
                },
                {
                    id: 2,
                    label: 'resource.subMenu'
                }
            ],
            statusArray: [
                {
                    id: 1,
                    label: 'resource.yes'
                },
                {
                    id: 0,
                    label: 'resource.no'
                }
            ],
            levelArray: [
                {
                    id: 0,
                    label: 'resource.allVisible'
                },
                {
                    id: 1,
                    label: 'resource.adminVisible'
                },
                {
                    id: 2,
                    label: 'resource.systemVisible'
                }
            ],
            treeOBJ: {},
            drawer: false,
            // 等级所对应的角色
            levelArrayTitle: ['public.level_0_role', 'public.level_1_role', 'public.level_2_role', 'public.level_3_role', 'public.level_4_role']
        };
    },
    mounted() {
        //   console.log(this.dioForm);
    },
    methods: {
        changeMenu(id) {
            switch (id) {
                case 1: {
                    this.levelArray = [
                        {
                            id: '0',
                            label: 'resource.allVisible'
                        },
                        {
                            id: '1',
                            label: 'resource.adminVisible'
                        },
                        {
                            id: '2',
                            label: 'resource.systemVisible'
                        }
                    ];
                    break;
                }
                case 2: {
                    if (this.treeChooze.view === 3) {
                        this.dioForm.view = '3';
                        this.levelArray = [
                            {
                                id: '2',
                                label: 'resource.systemVisible'
                            }
                        ];
                    } else {
                        this.dioForm.view = '1';
                        this.levelArray = [
                            {
                                id: '0',
                                label: 'resource.allVisible'
                            },
                            {
                                id: '1',
                                label: 'resource.adminVisible'
                            },
                            {
                                id: '2',
                                label: 'resource.systemVisible'
                            }
                        ];
                    }
                }
                default:
                    break;
            }
        },
        changeIcon() {
            this.drawer = true;
        },
        choozeIcon(icon) {
            this.drawer = false;
            this.$set(this.dioForm, 'icon', icon);
        },
        // 子组件的校验方法
        async justify() {
            try {
                return await this.$refs['form'].validate();
            } catch (error) {
                return false;
            }
        },
        clearValidate() {
            this.description = null;
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        }
    }
};
</script>

<style scoped>
.el-icon-question {
    cursor: pointer;
}
h3 {
    margin-left: 80px;
    margin-bottom: 15px;
    font-weight: bold;
}
i {
    cursor: pointer;
    font-size: 22px;
}
</style>
